module.exports = __webpack_public_path__ + "static/media/arrow.0a61280a.svg";